import { render } from "./PCUltimosVolcadosLote.vue?vue&type=template&id=660f23e7&scoped=true"
import script from "./PCUltimosVolcadosLote.vue?vue&type=script&lang=js"
export * from "./PCUltimosVolcadosLote.vue?vue&type=script&lang=js"

import "./PCUltimosVolcadosLote.vue?vue&type=style&index=0&id=660f23e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660f23e7"]])

export default __exports__